(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('SiteLocationController', SiteLocationController);

    SiteLocationController.$inject = ['$scope', '$state', 'SiteLocation', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter', 'clinic'];

    function SiteLocationController ($scope, $state, SiteLocation,  $q, DTColumnBuilder , DTOptionsBuilder, GUIUtils, $filter, clinic) {
        var vm = this;

        vm.siteLocations = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};
        vm.clinic = clinic;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                SiteLocation.getAllByClinic({id: vm.clinic.id}, function (result) {
                    vm.siteLocations = result;
                    defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.siteLocations, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip');

        vm.dtColumns = [
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function loadAll() {
            SiteLocation.query(function(result) {
                vm.siteLocations = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search () {
            vm.dtInstance.reloadData();
        }
    }
})();
